export const CLUB_EVENT = '/club-event/'
export const CLUB_EVENT_STATUS = `${CLUB_EVENT}status/` as const
